export default function extractFileType (file) {
  const mime = file.type
  const knownMimeMap = new Map([
    ['audio/mp3', 'audio'],
    ['video/mp4', 'video'],
    ['application/pdf', 'pdf'],
    [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'docx'
    ],
    [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'xlsx'
    ],
    [
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'pptx'
    ]
  ])

  if (mime) {
    if (mime.startsWith('image/')) return 'image'
    if (knownMimeMap.has(mime)) return knownMimeMap.get(mime)
    return mime
  }

  const ext = file.name
    ?.split('.')
    .pop()
    ?.toLowerCase()

  const extMap = new Map([
    ['pdf', 'pdf'],
    ['docx', 'docx'],
    ['xlsx', 'xlsx'],
    ['pptx', 'pptx'],
    ['png', 'image'],
    ['jpg', 'image'],
    ['jpeg', 'image'],
    ['gif', 'image'],
    ['bmp', 'image'],
    ['webp', 'image']
  ])

  return extMap.get(ext) || ext || 'unknow'
}
